const Promise = window.Promise || require('promise')
const request = require('superagent-promise')(require('superagent'), Promise)
const FORGAMERS_API_END_POINT = 'https://api.4gamers.com.tw/v1'
const NEWS = FORGAMERS_API_END_POINT + '/news/tag/WirForce'

const generateResponse = (res) => {
  const response = JSON.parse(res.text)
  // console.log(response)
  if (typeof response.data !== 'undefined' && typeof response.data === 'object') {
    console.log(response.meta)
    if (typeof response.meta !== 'undefined' && typeof response.meta === 'object') {
      return Promise.resolve(response)
    }
    return Promise.resolve(response.data)
  } else if (typeof response.data === 'undefined' && response.error.code === 200) {
    return Promise.resolve(null)
  } else {
    return Promise.reject({
      code: response.error.code,
      type: response.error.type,
      error: response.error
    })
  }
}

const generateErrorResponse = (err) => {
  console.log('error')
  return Promise.reject({
    err: err
  })
}

export default {
  FORGAMERS_API_END_POINT: FORGAMERS_API_END_POINT,
  news (page) {
    let req = request.get(NEWS).query('page=' + page)
    return req
      // .set('X-GAMERS-APP-KEY', 'Gamers 0ae99d77cc99460a49f94baf87028dfe030cc34ef2cdaae62804ea0b7aefee20')
      .end()
      .then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/forgamers.js